module.exports = __webpack_public_path__ + "static/img/5.cb65e2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/eng/5.png
// module id = NhOR
// module chunks = 0